import { createContext } from 'react';

export interface OrderContextProps {
  onEnableEdit: (onCallback: () => void) => void;
  onDisableEdit: (onCallback: () => void) => void;
  onDelete: () => void;
  onDownloadOrder: () => void;
}

export const OrderContext = createContext<OrderContextProps | null>(null);
